import { useReduxData } from './useReduxData';
import { loadEmployees } from '../store/employee/employeeSlice';
import { selectEmployeeLoaded, selectEmployees } from '../store/employee/selectors';

export const useEmployeesData = () => useReduxData(selectEmployees, selectEmployeeLoaded, loadEmployees);
